import { Text } from "@/components/ui";
import { cn } from "@/lib/utils/cn";
import type { ReactNode } from "react";

/** Matches {@link MattersStyleTableShell} body / subHeading cell typography. */
export function DataTableCellText({
  canHide,
  children,
  className,
}: {
  canHide: boolean;
  children: ReactNode;
  className?: string;
}) {
  return (
    <Text
      variant={canHide ? "subHeading" : "body"}
      className={cn(!canHide && "font-semibold", className)}
    >
      {children}
    </Text>
  );
}
